export type RecentlyViewedItem = {
  id: string;
  title: string;
  imageUrl: string | null;
  effectiveBest: number | null;
  platform: string;
};

const KEY = 'recently-viewed';
const MAX = 20;

// ---------------------------------------------------------------------------
// Storage
// ---------------------------------------------------------------------------

export function getRecentlyViewed(): RecentlyViewedItem[] {
  try {
    const raw: unknown = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(raw)
      ? raw.filter((x: unknown): x is RecentlyViewedItem => !!x && typeof x === 'object' && 'id' in x && 'title' in x)
      : [];
  } catch {
    return [];
  }
}

export function addRecentlyViewed(item: RecentlyViewedItem): void {
  try {
    const list = getRecentlyViewed();
    if (list[0]?.id === item.id) return;
    const deduped = list.filter((x) => x.id !== item.id);
    deduped.unshift(item);
    localStorage.setItem(KEY, JSON.stringify(deduped.slice(0, MAX)));
  } catch {
    // localStorage unavailable or quota exceeded — silently ignore
  }
}

// ---------------------------------------------------------------------------
// Recording (ItemDetailPage)
// ---------------------------------------------------------------------------

export function initRecentlyViewedRecorder(): void {
  const el = document.querySelector<HTMLElement>('[data-recently-viewed-record]');
  if (!el) return;
  const id = el.dataset.rvId;
  const title = el.dataset.rvTitle;
  if (!id || !title) return;
  addRecentlyViewed({
    id,
    title,
    imageUrl: el.dataset.rvImageUrl || null,
    effectiveBest: el.dataset.rvEffectiveBest ? Number(el.dataset.rvEffectiveBest) : null,
    platform: el.dataset.rvPlatform ?? '',
  });
}
